import { useRef, useEffect, useState } from 'react';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-buttons/js/buttons.html5';
import 'jszip/dist/jszip';
import 'pdfmake/build/pdfmake';
import 'pdfmake/build/vfs_fonts';
import { Icon } from '@iconify/react/dist/iconify.js';

const ReportDistrictWiseSummary = ({ overallDistrictData }) => {
  const tableRef = useRef(null);
  const [dataTable, setDataTable] = useState(null);
  const [totals, setTotals] = useState({
    totalUsers: 0,
    totalActivities: 0,
    totalPlants: 0
  });

  // Calculate totals
  useEffect(() => {
    if (overallDistrictData && overallDistrictData.length > 0) {
      const calculatedTotals = overallDistrictData.reduce((acc, district) => ({
        totalUsers: acc.totalUsers + (district.totalUsers || 0),
        totalActivities: acc.totalActivities + (district.totalActivities || 0),
        totalPlants: acc.totalPlants + (district.totalPlants || 0)
      }), { totalUsers: 0, totalActivities: 0, totalPlants: 0 });

      setTotals(calculatedTotals);
    } else {
      setTotals({ totalUsers: 0, totalActivities: 0, totalPlants: 0 });
    }
  }, [overallDistrictData]);

  // Initialize DataTable
  useEffect(() => {
    if (!overallDistrictData || overallDistrictData.length === 0 || !tableRef.current) return;

    const currentTable = tableRef.current; // Capture ref value

    // Destroy existing table
    if ($.fn.DataTable.isDataTable(currentTable)) {
      $(currentTable).DataTable().destroy();
    }

    // Initialize DataTable
    const table = $(currentTable).DataTable({
      dom: 'Bfrtip',
      buttons: [
        {
          extend: 'csv',
          text: 'Export CSV',
          className: 'btn-csv-export',
          exportOptions: { columns: ':visible' }
        }
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: true,
      info: false,
      autoWidth: false,
      order: [],
      columnDefs: [
        {
          targets: 0,
          data: null,
          render: (data, type, row, meta) => meta.row + 1,
          width: '50px',
          className: 'text-center'
        }
      ],
      footerCallback: function () {
        const api = this.api();
        $(api.column(2).footer()).html(totals.totalUsers);
        $(api.column(3).footer()).html(totals.totalActivities);
        $(api.column(4).footer()).html(totals.totalPlants.toLocaleString());
      }
    });

    setDataTable(table);

    // Cleanup: destroy on unmount
    return () => {
      if (table && $.fn.DataTable.isDataTable(currentTable)) {
        table.destroy();
      }
    };
  }, [overallDistrictData, totals]); // dataTable NOT in deps

  const exportToCSV = () => {
    if (dataTable) {
      dataTable.button('.btn-csv-export').trigger();
    }
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Overall District Wise Summary</h5>
        <button
          onClick={exportToCSV}
          className="btn btn-success btn-sm me-2 d-flex align-items-center"
          disabled={!overallDistrictData || overallDistrictData.length === 0}
        >
          <Icon icon="mdi:file-delimited-outline" className="me-1" style={{ fontSize: '16px' }} />
          Download CSV
        </button>
      </div>

      <div className="card-body">
        <div className="table-responsive">
          <table
            ref={tableRef}
            className="table vertical-striped-table mb-0 display"
            style={{ width: '100%' }}
          >
            <thead>
              <tr>
                <th scope="col" style={{ width: '50px', textAlign: 'center' }}>Sr.No.</th>
                <th scope="col">District</th>
                <th scope="col">Total Users</th>
                <th scope="col">Total Activities</th>
                <th scope="col">Total Plants</th>
              </tr>
            </thead>
            <tbody>
              {overallDistrictData && overallDistrictData.length > 0 ? (
                overallDistrictData.map((district, index) => (
                  <tr key={index}>
                    <td style={{ width: '50px', textAlign: 'center' }}>{index + 1}</td>
                    <td>
                      <h6 className="text-md mb-0 fw-normal">
                        {district.district || "Unknown District"}
                      </h6>
                    </td>
                    <td>{district.totalUsers}</td>
                    <td>{district.totalActivities}</td>
                    <td>{district.totalPlants.toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-20">
                    <div className="d-flex flex-column align-items-center">
                      <Icon icon="mdi:database-off" className="text-3xl text-muted mb-10" />
                      <p className="text-muted">No district data available</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              {overallDistrictData && overallDistrictData.length > 0 && (
                <tr className="fw-bold">
                  <td style={{ width: '50px' }}></td>
                  <td>TOTAL</td>
                  <td>{totals.totalUsers}</td>
                  <td>{totals.totalActivities}</td>
                  <td>{totals.totalPlants.toLocaleString()}</td>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ReportDistrictWiseSummary;